import React, { type ReactNode } from 'react';

export type PosCheckoutPanelProps = {
  cart?: ReactNode;
  header?: ReactNode;
  discounts?: ReactNode;
  shipping?: ReactNode;
  balance?: ReactNode;
  payment?: ReactNode;
  summary?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
  ariaLabel?: string;
  ariaModal?: boolean;
};

/**
 * Shell visual del checkout. No contiene estado comercial: los slots reciben
 * las mismas acciones y datos que usa el POS, por lo que desktop y mobile
 * siempre renderizan el mismo flujo.
 */
export const PosCheckoutPanel: React.FC<PosCheckoutPanelProps> = ({
  cart,
  header,
  discounts,
  shipping,
  balance,
  payment,
  summary,
  actions,
  children,
  className = '',
  ariaLabel = 'Checkout de venta',
  ariaModal = false,
}) => (
  <section className={`pos-checkout-panel ${className}`.trim()} aria-label={ariaLabel} role={ariaModal ? 'dialog' : undefined} aria-modal={ariaModal || undefined}>
    {header ? <header className="pos-checkout-panel__header">{header}</header> : null}
    <div className="pos-checkout-panel__scroll">
      {children ?? <>
        {cart}
        {discounts}
        {shipping}
        {balance}
        {payment}
        {summary}
      </>}
    </div>
    {actions ? <footer className="pos-checkout-panel__footer">{actions}</footer> : null}
  </section>
);

export default PosCheckoutPanel;
